
interface Specification {
  label: string;
  value: string;
}

interface ProductSpecificationsProps {
  specifications: Specification[];
}

export default function ProductSpecifications({ specifications }: ProductSpecificationsProps) {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Technical Specifications</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Detailed technical specifications and performance characteristics
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Specifications Table */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            <div className="bg-red-600 text-white px-6 py-4">
              <h3 className="text-xl font-semibold">Product Specifications</h3>
            </div>
            <div className="divide-y divide-gray-200">
              {specifications.map((spec, index) => (
                <div key={index} className="px-6 py-4 flex justify-between items-center hover:bg-gray-50">
                  <span className="text-gray-600 font-medium">{spec.label}</span>
                  <span className="text-gray-900 font-semibold text-right">{spec.value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Performance Chart */}
          <div className="bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-semibold text-gray-900 mb-6">Performance Overview</h3>
            
            <div className="space-y-6">
              <div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-700">Discharge Efficiency</span>
                  <span className="text-sm text-gray-500">95%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-red-600 h-2 rounded-full" style={{ width: '95%' }}></div>
                </div>
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-700">Fire Suppression Speed</span>
                  <span className="text-sm text-gray-500">90%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-orange-500 h-2 rounded-full" style={{ width: '90%' }}></div>
                </div>
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-700">Coverage Area</span>
                  <span className="text-sm text-gray-500">85%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-yellow-500 h-2 rounded-full" style={{ width: '85%' }}></div>
                </div>
              </div>

              <div>
                <div className="flex justify-between items-center mb-2">
                  <span className="text-sm font-medium text-gray-700">Reliability Rating</span>
                  <span className="text-sm text-gray-500">98%</span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2">
                  <div className="bg-green-500 h-2 rounded-full" style={{ width: '98%' }}></div>
                </div>
              </div>
            </div>

            <div className="mt-8 p-4 bg-blue-50 rounded-lg">
              <h4 className="font-semibold text-blue-900 mb-2">Operating Conditions</h4>
              <ul className="text-sm text-blue-800 space-y-1">
                <li>• Temperature Range: -10°C to +60°C</li>
                <li>• Humidity: Up to 95% RH</li>
                <li>• Storage: Dry, ventilated area</li>
                <li>• Maintenance: Annual inspection required</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
